import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';
import axios from 'axios';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset error state
    setError('');
    
    // Validate form
    if (!name || !email || !password || !confirmPassword) {
      setError('請填寫所有欄位');
      return;
    }

    // 姓名只能有中英文和數字
    if (!/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(name)) {
      setError('姓名只能包含中英文和數字，不能有特殊符號或空白');
      return;
    }

    // Email 格式檢查（只允許標準 email 字元）
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      setError('Email 格式不正確');
      return;
    }

    // 密碼只能有英數字
    if (!/^[a-zA-Z0-9]+$/.test(password)) {
      setError('密碼只能包含英文字母和數字，不能有特殊符號');
      return;
    }
    if (!/^[a-zA-Z0-9]+$/.test(confirmPassword)) {
      setError('確認密碼只能包含英文字母和數字，不能有特殊符號');
      return;
    }

    if (password !== confirmPassword) {
      setError('密碼確認不符');
      return;
    }

    if (password.length < 6) {
      setError('密碼至少需要6個字元');
      return;
    }
    
    try {
      setLoading(true);
      
      // Call register API
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/register`, {
        name,
        email,
        password
      });
      
      if (response.status === 201) {
        // Registration successful, redirect to login
        navigate('/login');
      }
      
    } catch (err) {
      console.error('Register error:', err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('註冊失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="register-container">
      <div className="register-card">
        <div className="register-header">
          <h1 className="register-title">Sign up</h1>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <form className="register-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">姓名<span style={{color: '#d32f2f'}}>*</span></label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={handleNameChange}
              placeholder="請輸入您的姓名"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email<span style={{color: '#d32f2f'}}>*</span></label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="請輸入您的電子郵件"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">密碼<span style={{color: '#d32f2f'}}>*</span></label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="請輸入您的密碼"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">確認密碼<span style={{color: '#d32f2f'}}>*</span></label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              placeholder="請確認您的密碼"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="register-button"
            disabled={loading}
          >
            {loading ? '註冊中...' : '註冊'}
          </button>
        </form>
        
        <div className="register-footer">
          <p>已有帳戶? <a href="/login" className="login-link">立即登入</a></p>
        </div>
      </div>
    </div>
  );
};

export default Register; 